import Vue from 'vue'
import Router from 'vue-router'
import index from './views/index.vue'

Vue.use(Router)

let arr = [];

let router = new Router({
	mode: 'hash', // 默认hash
	base: process.env.BASE_URL,
	scrollBehavior(to, from, savedPosition) { //跳转后，返回顶部
		if (savedPosition) {
			return savedPosition
		} else {
			return {
				x: 0,
				y: 0
			}
		}
	},
	routes: [
		{    path: '/index',  name: 'index',  component: index,  alias: '/'   },
		{
			path: '/index2',
			name: 'index2',
			component: () => import('./views/index2.vue')
		},
		{
			path: '/public',
			name: 'public',
			component: () => import('./views/public.vue')
		},
		{
			path: '/test',
			name: 'test',
			component: () => import('./views/test.vue')
		},

		{
			path: '/report',
			name: 'report',
			component: () => import('./views/report.vue')
		},
		{
			path: '/stepNumber',
			name: 'stepNumber',
			component: () => import('./views/stepNumber.vue')
		},
		{
			path: '/stepDataList',
			name: 'stepDataList',
			component: () => import('./views/stepDataList.vue')
		},
		{
			path: '/bloodPressure',
			name: 'bloodPressure',
			component: () => import('./views/bloodPressure.vue')
		},
		{
			path: '/bloodOxygen',
			name: 'bloodOxygen',
			component: () => import('./views/bloodOxygen.vue')
		},
		{
			path: '/bloodOxygenTotal',
			name: 'bloodOxygenTotal',
			component: () => import('./views/bloodOxygenTotal.vue')
		},
		{
			path: '/bloodOxygenTotal2',
			name: 'bloodOxygenTotal2',
			component: () => import('./views/bloodOxygenTotal.vue')
		},
		{
			path: '/bloodOxygenTotal3',
			name: 'bloodOxygenTotal3',
			component: () => import('./views/bloodOxygenTotal.vue')
		},
		{
			path: '/bloodOxygenTotal4',
			name: 'bloodOxygenTotal4',
			component: () => import('./views/bloodOxygenTotal.vue')
		},
		{
			path: '/bloodOxygenWrist',
			name: 'bloodOxygenWrist',
			component: () => import('./views/bloodOxygenWrist.vue')
		},
		{
			path: '/bloodOxygenWrist2',
			name: 'bloodOxygenWrist2',
			component: () => import('./views/bloodOxygenWrist.vue')
		},
		{
			path: '/bloodOxygenWrist3',
			name: 'bloodOxygenWrist3',
			component: () => import('./views/bloodOxygenWrist.vue')
		},
		{
			path: '/bloodOxygenWrist4',
			name: 'bloodOxygenWrist4',
			component: () => import('./views/bloodOxygenWrist.vue')
		},
		{
			path: '/bloodOxygenCS',
			name: 'bloodOxygenCS',
			component: () => import('./views/bloodOxygenCS.vue')
		},
		{
			path: '/bloodOxygenCS2',
			name: 'bloodOxygenCS2',
			component: () => import('./views/bloodOxygenCS.vue')
		},
		{
			path: '/bloodOxygenCS3',
			name: 'bloodOxygenCS3',
			component: () => import('./views/bloodOxygenCS.vue')
		},
		{
			path: '/bloodOxygenCS4',
			name: 'bloodOxygenCS4',
			component: () => import('./views/bloodOxygenCS.vue')
		},
		{
			path: '/heartRate',
			name: 'heartRate',
			component: () => import('./views/heartRate.vue')
		},
		{
			path: '/heartRateTotal',
			name: 'heartRateTotal',
			component: () => import('./views/heartRateTotal.vue')
		},
		{
			path: '/heartRateTotal2',
			name: 'heartRateTotal2',
			component: () => import('./views/heartRateTotal.vue')
		},
		{
			path: '/heartRateTotal3',
			name: 'heartRateTotal3',
			component: () => import('./views/heartRateTotal.vue')
		},
		{
			path: '/heartRateTotal4',
			name: 'heartRateTotal4',
			component: () => import('./views/heartRateTotal.vue')
		},
		{
			path: '/heartRateWrist',
			name: 'heartRateWrist',
			component: () => import('./views/heartRateWrist.vue')
		},
		{
			path: '/heartRateWrist2',
			name: 'heartRateWrist2',
			component: () => import('./views/heartRateWrist.vue')
		},
		{
			path: '/heartRateWrist3',
			name: 'heartRateWrist3',
			component: () => import('./views/heartRateWrist.vue')
		},
		{
			path: '/heartRateWrist4',
			name: 'heartRateWrist4',
			component: () => import('./views/heartRateWrist.vue')
		},
		{
			path: '/heartRateCS',
			name: 'heartRateCS',
			component: () => import('./views/heartRateCS.vue')
		},
		{
			path: '/heartRateCS2',
			name: 'heartRateCS2',
			component: () => import('./views/heartRateCS.vue')
		},
		{
			path: '/heartRateCS3',
			name: 'heartRateCS3',
			component: () => import('./views/heartRateCS.vue')
		},
		{
			path: '/heartRateCS4',
			name: 'heartRateCS4',
			component: () => import('./views/heartRateCS.vue')
		},
		{
			path: '/press',
			name: 'press',
			component: () => import('./views/press.vue')
		},
		{
			path: '/temperature',
			name: 'temperature',
			component: () => import('./views/temperature.vue')
		},
		{
			path: '/temperatureDayList',
			name: 'temperatureDayList',
			component: () => import('./views/temperatureDayList.vue')
		},

		{
			path: '/report2',
			name: 'report2',
			component: () => import('./views/report.vue')
		},
		{
			path: '/stepNumber2',
			name: 'stepNumber2',
			component: () => import('./views/stepNumber.vue')
		},
		{
			path: '/bloodPressure2',
			name: 'bloodPressure2',
			component: () => import('./views/bloodPressure.vue')
		},
		{
			path: '/bloodOxygen2',
			name: 'bloodOxygen2',
			component: () => import('./views/bloodOxygen.vue')
		},
		{
			path: '/heartRate2',
			name: 'heartRate2',
			component: () => import('./views/heartRate.vue')
		},
		{
			path: '/press2',
			name: 'press2',
			component: () => import('./views/press.vue')
		},
		{
			path: '/temperature2',
			name: 'temperature2',
			component: () => import('./views/temperature.vue')
		},


		{
			path: '/report3',
			name: 'report3',
			component: () => import('./views/report.vue')
		},
		{
			path: '/stepNumber3',
			name: 'stepNumber3',
			component: () => import('./views/stepNumber.vue')
		},
		{
			path: '/bloodPressure3',
			name: 'bloodPressure3',
			component: () => import('./views/bloodPressure.vue')
		},
		{
			path: '/bloodOxygen3',
			name: 'bloodOxygen3',
			component: () => import('./views/bloodOxygen.vue')
		},
		{
			path: '/heartRate3',
			name: 'heartRate3',
			component: () => import('./views/heartRate.vue')
		},
		{
			path: '/press3',
			name: 'press3',
			component: () => import('./views/press.vue')
		},
		{
			path: '/temperature3',
			name: 'temperature3',
			component: () => import('./views/temperature.vue')
		},


		{
			path: '/report4',
			name: 'report4',
			component: () => import('./views/report.vue')
		},
		{
			path: '/stepNumber4',
			name: 'stepNumber4',
			component: () => import('./views/stepNumber.vue')
		},
		{
			path: '/bloodPressure4',
			name: 'bloodPressure4',
			component: () => import('./views/bloodPressure.vue')
		},
		{
			path: '/bloodOxygen4',
			name: 'bloodOxygen4',
			component: () => import('./views/bloodOxygen.vue')
		},
		{
			path: '/heartRate4',
			name: 'heartRate4',
			component: () => import('./views/heartRate.vue')
		},
		{
			path: '/press4',
			name: 'press4',
			component: () => import('./views/press.vue')
		},
		{
			path: '/pressDataList',
			name: 'pressDataList',
			component: () => import('./views/pressDataList.vue')
		},
		{
			path: '/temperature4',
			name: 'temperature4',
			component: () => import('./views/temperature.vue')
		},
		{
			path: '/bloodPressureDayList',
			name: 'bloodPressureDayList',
			component: () => import('./views/bloodPressureDayList.vue')
		},
		{
			path: '/bloodPressureMonthList',
				name: 'bloodPressureMonthList',
			component: () => import('./views/bloodPressureMonthList.vue'),props: true
		},
		{
			path: '/bloodPressureDayDetail',
			name: 'bloodPressureDayDetail',
			component: () => import('./views/bloodPressureDayDetail.vue')
		},
		{
			path: '/bloodPressureReportApply',
			name: 'bloodPressureReportApply',
			component: () => import('./views/bloodPressureReportApply.vue')
		},
		{
			path: '/bloodPressureReportHisotryList',
			name: 'bloodPressureReportHisotryList',
			component: () => import('./views/bloodPressureReportHisotryList.vue')
		},
		{
			path: '/bloodPressureReportHisotryList2',
			name: 'bloodPressureReportHisotryList2',
			component: () => import('./views/bloodPressureReportHisotryList.vue')
		},
		{
			path: '/bloodPressureReportHisotryList3',
			name: 'bloodPressureReportHisotryList3',
			component: () => import('./views/bloodPressureReportHisotryList.vue')
		},
		{
			path: '/bloodPressureReportHisotryList4',
			name: 'bloodPressureReportHisotryList4',
			component: () => import('./views/bloodPressureReportHisotryList.vue')
		},
		{
			path: '/bloodPressureReport',
			name: 'bloodPressureReport',
			component: () => import('./views/bloodPressureReport.vue')
		},
		{
			path: '/bloodPressureReportApplyFail',
			name: 'bloodPressureReportApplyFail',
			component: () => import('./views/bloodPressureReportApplyFail.vue')
		},
		{
				path: '/userAgreement',
				name: 'userAgreement',
				component: () => import('./views/userAgreement.vue')
			},
			{
				path: '/guide/warn',
				name: 'guideWarn',
				component: () => import('./views/guideWarn.vue')
			},
			{
				path: '/guide/nibpIndex',
				name: 'guideSuanHuaWatchNibpIndex',
				component: () => import('./views/guideSuanHuaWatchNibpIndex.vue')
			},
			{
				path: '/guide/suanHuaTagNibpIndex',
				name: 'guideSuanHuaTagNibpIndex',
				component: () => import('./views/guideSuanHuaTagNibpIndex.vue')
			},
			{
				path: '/guide/video',
				name: 'guideVideo',
				component: () => import('./views/guideVideo.vue')
			},
			{
				path: '/measureDetails',
				name: 'measureDetails',
				component: () => import('./views/measureDetails.vue')
			},
			{
				path: '/privacy',
				name: 'privacy',
				component: () => import('./views/privacy.vue')
			},
			{
				path: '/privacyLaiKang',
				name: 'privacyLaiKang',
				component: () => import('./views/privacyLaiKang.vue')
			},
			{
				path: '/privacyMeiming',
				name: 'privacyMeiming',
				component: () => import('./views/privacyMeiming.vue')
			},
			{
				path: '/luonengprivacy',
				name: 'luonengprivacy',
				component: () => import('./views/luonengprivacy.vue')
			},
			{
				path: '/sportDataList',
				name: 'sportDataList',
				component: () => import('./views/sportDataList.vue')
			},
			{
				path: '/sportDataList2',
				name: 'sportDataList2',
				component: () => import('./views/sportDataList.vue')
			},
			{
				path: '/sportDataList3',
				name: 'sportDataList3',
				component: () => import('./views/sportDataList.vue')
			},
			{
				path: '/sportDataList4',
				name: 'sportDataList4',
				component: () => import('./views/sportDataList.vue')
			},
			{
				path: '/sportReport',
				name: 'sportReport',
				component: () => import('./views/sportReport.vue')
			},
			{
				path: '/sportReportLite',
				name: 'sportReportLite',
				component: () => import('./views/sportReportLite.vue')
			},
			{
				path: '/sportReportMaxHrSetting',
				name: 'sportReportMaxHrSetting',
				component: () => import('./views/sportReportMaxHrSetting.vue')
			},
			{
				path: '/sleepReport',
				name: 'sleepReport',
				component: () => import('./views/sleepReport.vue')
			},
			{
				path: '/sleepReport2',
				name: 'sleepReport2',
				component: () => import('./views/sleepReport.vue')
			},
			{
				path: '/sleepReport3',
				name: 'sleepReport3',
				component: () => import('./views/sleepReport.vue')
			},
			{
				path: '/sleepReport4',
				name: 'sleepReport4',
				component: () => import('./views/sleepReport.vue')
			},
			{
				path: '/bloodOxygenLiandai',
				name: 'bloodOxygenLiandai',
				component: () => import('./views/bloodOxygenLiandai.vue')
			},
			{
				path: '/heartRateLiandai',
				name: 'heartRateLiandai',
				component: () => import('./views/heartRateLiandai.vue')
			},
			{
				path: '/bloodPressureLiandai',
				name: 'bloodPressureLiandai',
				component: () => import('./views/bloodPressureLiandai.vue')
			},
			{
				path: '/bloodOxygenDayList',
				name: 'bloodOxygenDayList',
				component: () => import('./views/bloodOxygenDayList.vue')
			},
			{
				path: '/bloodOxygenDayListLiandai',
				name: 'bloodOxygenDayListLiandai',
				component: () => import('./views/bloodOxygenDayListLiandai.vue')
			},
			{
				path: '/heartRateDayList',
				name: 'heartRateDayList',
				component: () => import('./views/heartRateDayList.vue')
			},
			{
				path: '/heartRateDayListLiandai',
				name: 'heartRateDayListLiandai',
				component: () => import('./views/heartRateDayListLiandai.vue')
			},
			{
				path: '/bloodPressureMonthListLiandai',
				name: 'bloodPressureMonthListLiandai',
				component: () => import('./views/bloodPressureMonthListLiandai.vue')
			},
			{
				path: '/bloodPressureDayListLiandai',
				name: 'bloodPressureDayListLiandai',
				component: () => import('./views/bloodPressureDayListLiandai.vue')
			},
			{
				path: '/bloodPressureDayDetailLiandai',
				name: 'bloodPressureDayDetailLiandai',
				component: () => import('./views/bloodPressureDayDetailLiandai.vue')
			},
			{
				path: '/bloodPressureReportLiandai',
				name: 'bloodPressureReportLiandai',
				component: () => import('./views/bloodPressureReportLiandai.vue')
			},
			{
				path: '/bloodPressureReportApplyFailLiandai',
				name: 'bloodPressureReportApplyFailLiandai',
				component: () => import('./views/bloodPressureReportApplyFailLiandai.vue')
			},
			{
				path: '/bloodPressureReportApplyLiandai',
				name: 'bloodPressureReportApplyLiandai',
				component: () => import('./views/bloodPressureReportApplyLiandai.vue')
			},
			{
				path: '/deleteAccountUrl',
				name: 'deleteAccountUrl',
				component: () => import('./views/deleteAccountUrl.vue')
			},
		// {    path: '/user-*',  redirect:'/'  },
		{
			path: '*',
			redirect: '/'},
	]
})


// iphone iphone xr 微信浏览器 如果进入的不是首页 第二个路由会自动刷新
/*router.beforeEach((to, from, next) => {
    // console.log("前to：",to);
    // console.log("前arr：",arr);

    if(  arr.length===0 && to.name!=='index'  ){   // 非首页进入网站
        console.log("非首页进入网站---------");
		},
        arr.push(to);

        let redirect = to.fullPath;
        router.replace('/index?redirect=' + to.fullPath);
    }
    else if(  to.name==='index' && to.fullPath.includes('redirect')  ){
        console.log("重定向-----------");
        router.replace(to.query.redirect);
    }
    else{
        arr.push(to);
        next();
    }
})*/


export default router;
